import { useEffect } from "react";

export function useSeo(title, description) {
  useEffect(() => {
    document.title = title ? `${title} | SMT Provence` : "SMT Provence — Maçonnerie & aménagements extérieurs";
    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) { tag = document.createElement("meta"); tag.name = "description"; document.head.appendChild(tag); }
      tag.content = description;
    }
  }, [title, description]);
}
